<template>
    <div class="login-container">
        <!-- 主内容卡片 -->
        <div class="main-card">
            <!-- 左侧内容区域 -->
            <div class="left-content">
                <!-- Logo占位符 -->
                <div class="logo-placeholder">
                    <span class="logo-text">{{ companyName }}</span>
                </div>

                <!-- 宣传文字 -->
                <div class="slogan-text">
                    <p>诚信为发展之本，筑牢专业评审之基。</p>
                    <p>信息化夯实底座，赋能科学高效管理。</p>
                    <p>系统贯全周期，实现标准化服务保障。</p>
                    <p>数字赋能专家资源，构建精准专业画像。</p>
                    <p>多维评估为依据，公正量化能力绩效。</p>
                    <p>规范覆盖各节点，实现过程可溯可查。</p>
                    <p>评审标准化运营，构建公正权威生态。</p>
                </div>
            </div>

            <!-- 右侧登录卡片 -->
            <div class="login-card">
                <div class="card-header">
                    <h2 class="card-title">签章采集</h2>
                </div>

                <div class="login-form">
                    <div class="form-item">
                        <input type="text" v-model="loginForm.phone" placeholder="手机号" class="form-input" />
                    </div>

                    <!-- <div class="form-item">
                        <input type="password" v-model="loginForm.loginPassword" placeholder="登录密码"
                            class="form-input" />
                    </div> -->

                    <div class="form-item captcha-row">
                        <input type="text" v-model="loginForm.captchaCode" placeholder="验证码"
                            class="form-input captcha-input" />
                        <div class="captcha-placeholder" @click="sendSmsCode" :class="{ disabled: countdown > 0 }">
                            <span v-if="countdown === 0">获取验证码</span>
                            <span v-else>{{ countdown }}s</span>
                        </div>
                    </div>

                    <!-- <div class="form-actions">
                        <span class="forgot-link" @click="handleForgotPwd">忘记密码</span>
                    </div> -->

                    <button class="login-btn" @click="handleLogin">登录</button>

                    <div class="register-link">
                        还没有账号，请先 <span class="link-text" @click="handleRegister">注册</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { sendSmsCode, login } from '@/api/expertBank/api'
import Cookies from 'js-cookie'

export default {
    name: 'ExpertLogin',
    data() {
        return {
            loginForm: {
                phone: '',           // 手机号码
                loginPassword: '',   // 登录密码
                captchaCode: '',     // 验证码
                captchaUuid: ''      // 验证码唯一标识
            },
            countdown: 0,            // 倒计时秒数
            timer: null              // 定时器
        }
    },
    computed: {
        companyName() {
            return this.$channelMaterial.getCompanyName()
        },
        channelCode() {
            return this.$channelMaterial.getChannelCode()
        },
        deviceType() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 1 : 0
        },
    },
    methods: {
        // 发送短信验证码
        sendSmsCode() {
            // 如果正在倒计时，不允许重复发送
            if (this.countdown > 0) {
                return;
            }

            // 验证手机号
            if (!this.loginForm.phone.trim()) {
                this.$message.error('请先输入手机号');
                return;
            }

            const phoneReg = /^1[3-9]\d{9}$/;
            if (!phoneReg.test(this.loginForm.phone)) {
                this.$message.error('请输入正确的手机号');
                return;
            }

            sendSmsCode({ phone: this.loginForm.phone }).then(res => {
                if (res.code === 200) {
                    this.$message.success('验证码发送成功');
                    this.startCountdown();
                    this.loginForm.captchaUuid = res.data.uuid;
                } else {
                    this.$message.error(res.msg || '获取验证码失败');
                }
            }).catch(error => {
                console.error('发送验证码失败:', error);
                this.$message.error('网络异常，请稍后重试');
            });
        },

        // 开始倒计时
        startCountdown() {
            this.countdown = 60;
            this.timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    this.clearCountdown();
                }
            }, 1000);
        },

        // 清除倒计时
        clearCountdown() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.countdown = 0;
        },

        // 登录逻辑
        async handleLogin() {
            // 表单验证
            if (!this.validateForm()) {
                return;
            }
            try {
                const loginData = {
                    phone: this.loginForm.phone,
                    loginPassword: this.loginForm.loginPassword,
                    captchaCode: this.loginForm.captchaCode,
                    captchaUuid: this.loginForm.captchaUuid,
                    channelCode:this.channelCode,
                    deviceType:1
                };
                const res = await login(loginData);
                if (res.code === 200) {
                    if (res.data.caRegisterUrl != '' || res.data.caRegisterUrl != 'null'  || res.data.caRegisterUrl !=null) {
                        return window.open(res.data.caRegisterUrl, '_blank');
                    }
                    this.$message.success('登录成功');
                    if (res.data && res.data.token) {
                        Cookies.set('token', res.data.token)
                    }
                    this.$router.push('/expertBankHome');
                } else {
                    this.$message.error(res.msg || '登录失败');
                }
            } catch (error) {
                console.error('登录失败:', error);
                this.$message.error('网络异常，请稍后重试');
            }
        },

        // 表单验证
        validateForm() {
            const { phone, loginPassword, captchaCode } = this.loginForm;
            if (!phone.trim()) {
                this.$message.error('请输入手机号');
                return false;
            }
            const phoneReg = /^1[3-9]\d{9}$/;
            if (!phoneReg.test(phone)) {
                this.$message.error('请输入正确的手机号');
                return false;
            }
            // if (!loginPassword.trim()) {
            //     this.$message.error('请输入登录密码');
            //     return false;
            // }
            if (!captchaCode.trim()) {
                this.$message.error('请输入验证码');
                return false;
            }
            return true;
        },

        handleRegister() {
            // 注册逻辑
            this.$router.push('/expertBankRegister');
        },

        handleForgotPwd() {
            // 忘记密码逻辑
            this.$router.push('/expertBankForgetPwd');
        }
    },

    // 组件销毁时清除定时器
    beforeDestroy() {
        this.clearCountdown();
    }
}
</script>

<style lang="less" scoped>
.login-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #4A90E2 0%, #357ABD 50%, #2E5B8A 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 200px;
        background: linear-gradient(to top, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
        pointer-events: none;
    }
}

.main-card {
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    display: flex;
    overflow: hidden;
    min-height: 480px;
}

.left-content {
    width: 400px;
    background: linear-gradient(135deg, #4A90E2 0%, #357ABD 50%, #2E5B8A 100%);
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
}

.logo-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    .logo-text {
        color: white;
        font-size: 18px;
        font-weight: bold;
    }
}

.slogan-text {
    font-size: 16px;
    line-height: 2;

    p {
        margin: 0 0 8px 0;
        opacity: 0.95;
    }
}

.login-card {
    background: white;
    padding: 40px;
    width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.card-header {
    text-align: center;
    margin-bottom: 40px;
}

.card-title {
    font-size: 20px;
    color: #333;
    margin: 0;
    font-weight: 500;
}

.login-form {
    .form-item {
        margin-bottom: 20px;

        &.captcha-row {
            display: flex;
            gap: 12px;
        }
    }

    .form-input {
        width: 100%;
        height: 48px;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        padding: 0 16px;
        font-size: 14px;
        outline: none;
        transition: border-color 0.3s;

        &:focus {
            border-color: #4A90E2;
        }

        &::placeholder {
            color: #999;
        }

        &.captcha-input {
            flex: 1;
        }
    }

    .captcha-placeholder {
        width: 100px;
        height: 48px;
        background-color: #4A90E2;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 12px;
        cursor: pointer;
        transition: background-color 0.3s ease;

        &:hover {
            background-color: #357ABD;
        }

        &.disabled {
            background-color: #ccc;
            cursor: not-allowed;

            &:hover {
                background-color: #ccc;
            }
        }
    }

    .form-actions {
        text-align: right;
        margin-bottom: 30px;
    }

    .forgot-link {
        color: #4A90E2;
        font-size: 14px;
        cursor: pointer;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    .login-btn {
        width: 100%;
        height: 48px;
        background: #4A90E2;
        color: white;
        border: none;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.3s;
        margin-bottom: 20px;

        &:hover {
            background: #357ABD;
        }

        &:active {
            background: #2E5B8A;
        }
    }

    .register-link {
        text-align: center;
        font-size: 14px;
        color: #666;

        .link-text {
            color: #ff4444;
            cursor: pointer;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }
}

@media (max-width: 768px) {
    .login-container {
        flex-direction: column;
        padding: 20px;
    }

    .left-content {
        margin-right: 0;
        margin-bottom: 40px;
        text-align: center;
        max-width: 100%;
    }

    .login-card {
        width: 100%;
        max-width: 400px;
        padding: 30px 20px;
    }
}
</style>